// extracted by mini-css-extract-plugin
export default {"betslipContainer":"BetslipWidget_betslipContainer__Ks5El","open":"BetslipWidget_open__L5glB"};